<label class="mt-4">Etapa {{ current() }} de {{ total() }}</label>
